import { FC } from 'react';
import { ChartSeriesType, TableTileColumnVisualization } from '@common/api';
import { ChartDatumPoint } from '@components/chart';
import { Text } from '@components/typography/Typography';
import { GridRowCell, GridRowEllipsis } from './TableTile.style';

export type TextAlign = 'left' | 'center' | 'right';

export type TableTileCellProps = {
    align: TextAlign;
    point: ChartDatumPoint | null;
    columnVisualization: Required<TableTileColumnVisualization>;
};

export const TableTileCell: FC<TableTileCellProps> = (props: TableTileCellProps) => {
    const { align, point, columnVisualization } = props;

    const color = point && columnVisualization.type === ChartSeriesType.DataChart ? point.color : undefined;

    return (
        <GridRowCell $flexGrow={1} $align={align} $overflow="hidden" $color={color}>
            <GridRowEllipsis>{point?.label ?? <Text $transparent>–</Text>}</GridRowEllipsis>
        </GridRowCell>
    );
};
